import { reactive, ref } from "vue";
import Axios from "@/assets/js/axios";

export function useApiHandler(postUrl, deleteUrl, onUpdated, onDeleted) {
  const errors = ref({});
  const $http = Axios.http;

  const loading = reactive({
    save: false,
    delete: false,
    common: false
  });

  const getErrorMessages = field => {
    if (errors.value[field]) return errors.value[field] ? errors.value[field][0] : "";
  };

  const setErrorMessages = error => {
    errors.value = error.response.data["fieldErrors"];
  };
  const clearErrorMessages = () => {
    errors.value = {};
  };

  const saveRecord = async (data, url = postUrl, options = {}) => {
    const { skipLoading = false, customLoadingKey = null, onStart = null, onFinally = null } = options;

    if (!skipLoading) {
      loading.save = true;
      loading.common = true;
      if (customLoadingKey) loading[customLoadingKey] = true;
    }

    onStart && onStart();

    return $http
      .post(url, data)
      .then(response => {
        onUpdated ? onUpdated(response, data) : null;
        return Promise.resolve(response);
      })
      .catch(error => {
        if (error.response.data["fieldErrors"]) {
          setErrorMessages(error);
        }
        return Promise.reject(error);
      })
      .finally(() => {
        if (!skipLoading) {
          loading.save = false;
          loading.common = false;
          if (customLoadingKey) loading[customLoadingKey] = false;
        }
        onFinally && onFinally();
      });
  };

  const deleteRecord = async (id, url = deleteUrl, options = {}) => {
    const { skipLoading = false, customLoadingKey = null, onStart = null, onFinally = null } = options;

    if (!skipLoading) {
      loading.delete = true;
      loading.common = true;
      if (customLoadingKey) loading[customLoadingKey] = true;
    }

    onStart && onStart();

    return $http
      .delete(url + "/" + id)
      .then(response => {
        // this.$emit("deleted", response);
        onDeleted ? onDeleted(response) : null;
        return Promise.resolve(response);
      })
      .catch(error => {
        return Promise.reject(error);
      })
      .finally(() => {
        if (!skipLoading) {
          loading.delete = false;
          loading.common = false;
          if (customLoadingKey) loading[customLoadingKey] = false;
        }
        onFinally && onFinally();
      });
  };

  return {
    getErrorMessages,
    setErrorMessages,
    clearErrorMessages,
    saveRecord,
    deleteRecord,
    loading
  };
}
